import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CabsandPrestartPage } from './cabsand-prestart';

@NgModule({
  declarations: [
    CabsandPrestartPage,
  ],
  imports: [
    IonicPageModule.forChild(CabsandPrestartPage),
  ],
})
export class CabsandPrestartPageModule {}



// WEBPACK FOOTER //
// ./src/pages/cabsand-prestart/cabsand-prestart.module.ts